import { render, staticRenderFns } from "./RouterContainer.vue?vue&type=template&id=9a77f27a&scoped=true"
import script from "./RouterContainer.vue?vue&type=script&lang=js"
export * from "./RouterContainer.vue?vue&type=script&lang=js"
import style0 from "./RouterContainer.vue?vue&type=style&index=0&id=9a77f27a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a77f27a",
  null
  
)

export default component.exports